// @flow
import queryString from 'query-string';
import {
  UTM_CAMPAIGN,
  UTM_CONTENT,
  UTM_CREATIVE,
  UTM_MEDIUM,
  UTM_SOURCE,
  UTM_TERM,
} from '../UTMParams.constants';

export type UTMParams = {
  utm_campaign?: string,
  utm_content?: string,
  utm_creative?: string,
  utm_medium?: string,
  utm_source?: string,
  utm_term?: string,
};

export type Location = {
  search: string,
}

export const addUTMParamsToURL = (
  destinationUrl: string,
  utmParams: UTMParams = {},
  currentLocation: Location = {
    search: '',
  },
) => {
  const {
    query: destinationSearchParams,
    url: destinationUrlWithoutSearchParams,
  } = queryString.parseUrl(destinationUrl);

  if (destinationUrl === '#') { // HACK - prevents reload on services tab
    return '#';
  }

  const {
    [UTM_CAMPAIGN]: utmCampaign,
    [UTM_CONTENT]: utmContent,
    [UTM_CREATIVE]: utmCreative,
    [UTM_MEDIUM]: utmMedium,
    [UTM_SOURCE]: utmSource,
    [UTM_TERM]: utmTerm,
  } = queryString.parse(currentLocation.search);


  const combinedSearchParams = {
    [UTM_CAMPAIGN]: utmCampaign,
    [UTM_CONTENT]: utmContent,
    [UTM_CREATIVE]: utmCreative,
    [UTM_MEDIUM]: utmMedium,
    [UTM_SOURCE]: utmSource,
    [UTM_TERM]: utmTerm,
    ...destinationSearchParams,
    ...utmParams,
  };

  return `${destinationUrlWithoutSearchParams}?${queryString.stringify(combinedSearchParams)}`;
};

export default addUTMParamsToURL;
